<template>
    <div class="app-main goods-list">

        
        <div class="top-bar">
            <el-input placeholder="输入商品名称" v-model="value" @change="search()" style="width:210px;margin-right:20px;" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button  @click="showDialog()" type="success" plain >修改商品分类</el-button>
        </div>
        <!-- 商品列表 -->
        <el-card shadow="hover">
            <el-table ref="multipleTable" :data="tableData"  height="600" @selection-change="handleSelectionChange">
                 <el-table-column type="selection" align="center" width="60"></el-table-column>
                <el-table-column label="商品图片" align="center" width="150">
                    <template slot-scope="scope">
                        <m-img v-if="scope.row.image_url" :src="scope.row.image_url" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="商品名称"  align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="visits"      align="center" label="浏览量"></el-table-column>
                <el-table-column  prop="sales_volume" align="center" label="商品销量" sortable></el-table-column>
                <el-table-column prop="status" align="center" label="商品分类" width="200">
                    <template slot-scope="scope">
                        <div class="table-btns" v-for="it in scope.row.type_list" :key="it.type_id">
                            <!-- <el-popconfirm title="确定删除此分类吗？"  v-for="it in scope.row.type_list" :key="it.type_id" @onConfirm="handleDel(scope.row.id, it.type_id)">
                                <el-link  slot="reference" type="success">{{it.type_name}}</el-link>
                            </el-popconfirm> -->
                            <el-link  slot="reference" type="success">{{it.type_name}}</el-link>
                        </div>
                    </template>
                </el-table-column>
                
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px"  :total="total" :page-size="size" ></el-pagination>
        </el-card>


        <el-dialog title="选择分类进行修改" :visible.sync="dialog" width="800px" center>
            <el-card class="m-bottom-4">
                 <el-row >
                    <el-col :span="3" class="input-left">
                        选择分类：
                    </el-col>
                    <el-col :span="21">
                        <el-select v-model="pid" filterable multiple  placeholder="选择分类" style="width:600px">
                            <el-option v-for="item in classify" :key="item.id" :label="item.title" :value="item.id" ></el-option>
                        </el-select>
                    </el-col>
                </el-row>
            </el-card>
         
            <el-card>
                <el-row >
                    <el-col :span="3" class="input-left">
                        确认修改：
                    </el-col>
                    <el-col :span="21">
                        <el-button :disabled="disabled"  @click="handleBtn()" type="success" plain>确认修改</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </el-dialog>


    </div>
</template>



<script>
/* eslint-disable */
import { goods_classify_list, classify_list, goods_classify_edit, goods_classify_del  } from '@/api/goods.js'

import MImg   from './../../../components/Image'

export default {
    components: { MImg },
    data() {
        return {
            value:'',
            tableData:[],
            total:0,
            page:1,
            size: 50,
            classify: [],                 // 二级分类数据
            goods_id: [],                   //选中的商品ID
            pid: [],
            dialog: false,
        }
    },
    methods: {
        search() {
            this.page = 1
            this.getData()
        },
        getData(){
            this.tableData = [];
            let params = {
                page:this.page,
            }
            if(this.value != ""){
                params.search = this.value;
            }
            goods_classify_list(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                    this.size  = res.data.per_page
                }else{
                    this.tableData = []
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
            this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
        },

        // 获取二级分类数据
        getClassify() {
            let params = {
                level:2,
            }
            classify_list(params).then(res => {
                if(res) {
                    this.classify = res.data
                }else{
                    this.classify = []
                }
            })
        },
        
        // 选中表格数据
        handleSelectionChange(rows) {
            this.goods_id = []
            rows.forEach(e => {
                this.goods_id.push(e.id)
            });
        },

        // 点击修改商品分类
        showDialog() {
            if(this.goods_id.length > 0) {
                this.dialog = true
            }else{
                this.$message.error('至少选中一个商品进行修改分类')
            }
        },

        // 确定修改商品分类
        handleBtn() {  
            if(this.pid.length == 0){
                this.$message.error('至少选中一个分类进行修改')
            }else {
                let params = {  
                    goods_ids: this.goods_id,
                    type_ids: this.pid
                }
                goods_classify_edit(params).then(res => {  
                    if(res){
                        this.$message({ type: 'success', message: res.msg })
                        this.pid = []
                        this.getData()
                    }
                }).finally( () => {
                    this.dialog = false
                })
            }
        },

        //  删除分类
        handleDel(goodsid, typeid) {  
            let params = {  
                type_id: typeid,
                goods_id: goodsid
            }
            goods_classify_del(params).then(res => {  
                if(res){
                    this.$message({ type: 'success', message: res.msg })
                    this.getData()
                }
            })
        },
    },
    created(){
        this.getData()
        this.getClassify()
    },
    activated() {
        this.getData()
    },
}
</script>

<style lang="less" scoped>
.input-left {
    line-height: 40px;
    min-width: 80px;
}
</style>
